import React from "react"
import { useIntl } from "gatsby-plugin-intl"

import * as styles from "./FeaturedProjects.module.scss"

import Button from "../../../UI/Button/Button"

import ProjectsList from "../../../Parts/ProjectsList/ProjectsList"

const FeaturedProjects: React.FC = () => {
	const intl = useIntl()

	return (
		<section className={styles.projects}>
			<ProjectsList showLoadMore={false} />
			<Button className={styles.button} variant="border" to={"/projects"}>{intl.formatMessage({ id: "index.projects.link" })}</Button>
		</section>
	)
}

export default FeaturedProjects
